import { render, staticRenderFns } from "./preparations.vue?vue&type=template&id=86d5a7d6"
import script from "./preparations.vue?vue&type=script&lang=js"
export * from "./preparations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86d5a7d6')) {
      api.createRecord('86d5a7d6', component.options)
    } else {
      api.reload('86d5a7d6', component.options)
    }
    module.hot.accept("./preparations.vue?vue&type=template&id=86d5a7d6", function () {
      api.rerender('86d5a7d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basicconfig/preparations.vue"
export default component.exports